import "./ConfigurationGroupReportingEdit.html";
import "./ConfigurationGroupReportingEdit.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupReportingEditComponentController from "./ConfigurationGroupReportingEditComponentController";

import "../../../../Forms/EditNotificationSubscriptions/EditNotificationSubscriptionsComponent";

export default class ConfigurationGroupReportingEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfigurationGroupReportingEditComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/Reporting/Edit/ConfigurationGroupReportingEdit.html";
    }
}

module("mmManagePortal").component("mmConfigurationGroupReportingEdit", new ConfigurationGroupReportingEditComponent());
